<template>
  <div
    v-if="blocks"
  >
    <div
      class="flex gap-4"
      :class="isHalf ? 'flex-col lg:flex lg:flex-row' : 'hidden lg:grid grid-cols-[2fr_1fr]'"
    >
      <BannerBox
        v-for=" block in firstTwoBlocks"
        :key="block.header"
        :strap-icon-class="block.strapIconClass"
        :strap-icon-color="block.strapIconColor"
        :header="block.header"
        :header-type="block.headerType"
        :header-icon-class="block.headerIconClass"
        :header-icon-color="block.headerIconColor"
        :header-image="block.headerImage"
        :header-image-alt="block.headerImageAlt"
        :description="block.description"
        :button-text="block.buttonText"
        :image="block.image"
        :mobile-image="block.mobileImage"
        :mobile-image-auto-height="block.mobileImageAutoHeight"
        :display-strap="block.displayStrap"
        :link="block.link"
        :is-full-image="block.isFullImage"
        :is-box-full="block.isBoxFull"
        :has-button="block.hasButton"
        :is-mini="block.isMini"
        :is-medium="block.isMedium"
        :background-color="block.backgroundColor"
        :is-half="block.isHalf"
        :text-color="block.textColor"
        :badge-text="block.badgeText"
        :box-background="block.boxBackground"
        :is-button-round-mobile="block.isButtonRoundMobile"
        :strap-background="block.strapBackground"
        :button-type="block.buttonType"
        :badge-color="block.badgeColor"
      />
    </div>
    <div
      v-if="!isHalf"
      class="lg:hidden"
    >
      <SimpleCarousel
        :slider-items="
          firstTwoBlocks"
        :per-page="1"
        slide-class="justify-center"
        :show-pagination-controls="showPaginationControls"
      >
        <template
          #default="{ currentItem }"
        >
          <BannerBox
            :key="currentItem.header"
            :strap-icon-class="currentItem.strapIconClass"
            :strap-icon-color="currentItem.strapIconColor"
            :header="currentItem.header"
            :header-type="currentItem.headerType"
            :header-icon-class="currentItem.headerIconClass"
            :header-icon-color="currentItem.headerIconColor"
            :header-image="currentItem.headerImage"
            :header-image-alt="currentItem.headerImageAlt"
            :description="currentItem.description"
            :button-text="currentItem.buttonText"
            :image="currentItem.image"
            :mobile-image="currentItem.mobileImage"
            :mobile-image-auto-height="currentItem.mobileImageAutoHeight"
            :display-strap="currentItem.displayStrap"
            :link="currentItem.link"
            :is-full-image="currentItem.isFullImage"
            :is-box-full="currentItem.isBoxFull"
            :has-button="currentItem.hasButton"
            :is-mini="currentItem.isMini"
            :is-medium="currentItem.isMedium"
            :background-color="currentItem.backgroundColor"
            :is-half="currentItem.isHalf"
            :text-color="currentItem.textColor"
            :badge-text="currentItem.badgeText"
            :box-background="currentItem.boxBackground"
            :is-button-round-mobile="currentItem.isButtonRoundMobile"
            :strap-background="currentItem.strapBackground"
            :button-type="currentItem.buttonType"
            :badge-color="currentItem.badgeColor"
          />
        </template>
      </SimpleCarousel>
    </div>
  </div>
</template>

<script lang="ts">
import SimpleCarousel from '~/components/molecules/SimpleCarousel/SimpleCarousel.vue';
import BannerBox from '~/cms/BannerBox/BannerBox.vue';
import type { BannerBox as BannerBoxType } from '~~/types/cms/BannerBox';

export default defineComponent({
  name: 'BannerBoxes',
  components: {
    BannerBox,
    SimpleCarousel,
  },
  props: {
    blocks: {
      type: Array as PropType<BannerBoxType[]>,
      default: () => {

        return [];
      
      },
    },
    isHalf: {
      type: Boolean,
      default: false,
    },
    showPaginationControls: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {

    const firstTwoBlocks = computed(() => props.blocks.slice(0, 2));

    return {
      firstTwoBlocks,
    };
  
  },
});
</script>
